import { render, staticRenderFns } from "./SubjectSelectList.vue?vue&type=template&id=56f4f8db&scoped=true&"
import script from "./SubjectSelectList.vue?vue&type=script&lang=js&"
export * from "./SubjectSelectList.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSelectList.vue?vue&type=style&index=0&id=56f4f8db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4f8db",
  null
  
)

export default component.exports